import { connect } from "react-redux";
import { toggleHideComment, hideComment } from "project/ducks/revisions";
import { getProjectEntriesState } from "project/ducks/entries";
import ConfirmationDialog from "common/components/modal/confirmation_dialog";

const mapStateToProps = (state) => {
  const { hidingComment } = getProjectEntriesState(state);

  return {
    dialogVisible: !!hidingComment,
    dialogHeader: "Delete comment",
    dialogTitle: "Confirm deletion",
    dialogMessage: `Are you sure you want to delete this comment? This action cannot be undone.`,
  };
};

export default connect(mapStateToProps, {
  submitAction: hideComment,
  toggleDialog: () => toggleHideComment(null),
})(ConfirmationDialog);
